import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetBillingPortalUrlArgs } from "../schemas";

const getBillingPortalUrlQueryKey = (args: GetBillingPortalUrlArgs) =>
  ["getBillingPortalUrl", args.health_care_organization_id] as const;

export const useGetBillingPortalUrl = (args: GetBillingPortalUrlArgs) => {
  const client = useApiClient();
  return useQuery(getBillingPortalUrlQueryKey(args), () => client.getBillingPortalUrl(args));
};
